import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/content/images/assets/icons/planet-biker.svg")